// extracted by mini-css-extract-plugin
module.exports = {"iframe-with-padding":"IFrame_iframe-with-padding__yQb1Z"};